import { createQueryKeys } from "@lukemorales/query-key-factory";
import { MenuHierarchiesApi } from "mws-ts-v2-sdk";
import { unref } from "vue";

import { getUniversalAxios } from "~/utils/axios/getUniversalAxios";

const getMenuHierarchiesApi = () => {
  return new MenuHierarchiesApi(
    undefined,
    useRuntimeConfig().public.catalogServiceUrl,
    getUniversalAxios(),
  );
};
export const menuHierarchyQueryKeys = createQueryKeys("menuHierarchies", {
  treeForIdsWithLiveEvents: (
    menuHierarchyId: MaybeRef<string>,
    xPlatformKey: MaybeRef<string>,
  ) => ({
    queryKey: [menuHierarchyId],
    queryFn: async () => {
      const response = await getMenuHierarchiesApi().v2MenuHierarchiesGet({
        xPlatformKey: unref(xPlatformKey),
        menuHierarchyIds: unref(menuHierarchyId),
        includeLiveEvents: true,
      });

      return response.data;
    },
  }),
});
